import React, { lazy } from "react";
import PropTypes from "prop-types";

import LDJsonSchema from "components/LDJsonSchema";
import LoadingModal from "components/LoadingModal";
import MetaTags from "components/MetaTags";
import { useRouter, useFaces, useGlobalLoading, useFilestack } from "hooks";
import FaceUploadModal from "components/FaceUploadModal";
import MetaRobots from "components/MetaRobots";

import Header from "./components/Header";
import Footer from "./components/Footer";
import useStyles from "./useStyles";

const PickerOverlay = lazy(() => import("components/FaceUploadModal/components/PickerOverlay/PickerOverlay"));

const UserLayout = (props) => {
  const classes = useStyles();
  const { children } = props;
  const { modalOpened } = useFaces();
  const { isPending, labelFunc } = useGlobalLoading();
  const {
    pathname,
    camelizedQuery: { readable },
  } = useRouter();
  const { origin } = window.location;
  const url = `${origin}${pathname}`;
  const isLegalPage = pathname.match(/\/legal|\/privacy|\/terms-of-service|\/terms-of-sale/);
  const isMakeViewPage = pathname.match(/\/view\/make\/|\/view\/make-preview\//);
  const readableView = readable && isLegalPage ? readable === "true" : false;
  const showHeader = !readableView && !isMakeViewPage;
  const siteSchema = {
    "@context": "http://schema.org",
    "@type": "WebSite",
    name: "JibJab",
    url: "https://www.jibjab.com/",
  };
  const { handleView } = useFilestack();

  return (
    <div className={classes.root}>
      {showHeader && <Header />}
      <main className={showHeader ? classes.main : ""}>{children}</main>
      {!readableView && <Footer />}
      <LDJsonSchema schema={siteSchema} />
      <MetaTags>
        <link rel="canonical" href={`${origin}${pathname.replace(/\/$/, "")}`} />
        <meta property="og:site_name" content="JibJab" />
        <meta property="og:url" content={url} />
        <meta property="og:type" content="website" />
      </MetaTags>
      <MetaRobots />
      {modalOpened && <FaceUploadModal />}
      {handleView && <PickerOverlay />}
      {isPending && <LoadingModal labelFunc={labelFunc} />}
    </div>
  );
};

UserLayout.propTypes = {
  children: PropTypes.node,
};

export default UserLayout;
